import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  margin-top: 16px;
  gap: 16px;
`;
